module.exports = __webpack_public_path__ + "static/img/10.4d73fab7.jpg";